<div
    class="componentList"
    *ngIf="isComponentDataReady"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    [ngClass]="{ printpreview: viewMode <= 1 }"
>
    <div class="selected-components">
        <div *ngFor="let selectedComponent of componentData; let componentIndex = index">
            <div
                class="selected-components__item"
                [ngClass]="{ 'selected-components__item--hidden': selectedComponent.isHidden }"
                [ngSwitch]="selectedComponent.componentName"
                cdkDrag
            >
                <div class="component-header">
                    <div class="drag-and-title-container">
                        <span class="ham-icon drag-icon" cdkDragHandle>
                            <i class="dots-grid-icon"></i>
                        </span>
                        <ham-referencing-input-component
                            class="component-title"
                            [isEditMode]="true"
                            [title]="notesNumberedTitles[componentIndex]?.componentTitle"
                            [numbering]="notesNumberedTitles[componentIndex]?.componentNumber"
                            [isNumbered]="selectedComponent.addNumbering"
                            [isReferenced]="selectedComponent.referenceFlis?.length > 0"
                            (titleChange)="onComponentTitleChange($event, selectedComponent, componentIndex)"
                            (addNumbering)="onAddComponentNumberToggleEmit(selectedComponent, componentIndex)"
                            (addReferencing)="onOpenComponentReferenceDialog(selectedComponent, componentIndex)"
                        ></ham-referencing-input-component>
                        <span *ngIf="selectedComponent.isHidden" class="component-hidden-badge">
                            {{ 'aumico_notes_component_hidden_badge' | i18next }}
                        </span>
                    </div>

                    <notes-actions-palette
                        #dynamicNotesActionsPalette
                        class="selected-components__actions"
                        [isSaveDisabled]="formStatus[componentIndex]"
                        [isEditing]="true"
                        [hasResetFromMappingButton]="
                            selectedComponent.componentName === componentNames.SUPER_TABLE ||
                            selectedComponent.componentName === componentNames.FINANCIAL_LINE_ITEM ||
                            selectedComponent.componentName === componentNames.MOVEMENT_SCHEDULE
                        "
                        [hasCopyButton]="
                            selectedComponent.componentName === componentNames.FREE_TABLE_WITH_AMOUNTS ||
                            selectedComponent.componentName === componentNames.SUPER_TABLE
                        "
                        [hasFootnoteButton]="
                            selectedComponent.componentName !== componentNames.RICH_TEXT &&
                            selectedComponent.componentName !== componentNames.INPUT &&
                            selectedComponent.componentName !== componentNames.EQUITY
                        "
                        [hasTotalRowButton]="
                            selectedComponent.componentName === componentNames.FREE_TABLE_WITH_AMOUNTS ||
                            selectedComponent.componentName === componentNames.EQUITY
                        "
                        [hasEditButton]="false"
                        [hasSaveButton]="false"
                        [transpose]="selectedComponent.data.options?.transpose"
                        [flipSign]="selectedComponent.data.options?.flipSign"
                        [totalRow]="selectedComponent.data.options?.totalRow"
                        [compareYears]="selectedComponent.data.options?.compareYears"
                        [showFiscalYear]="selectedComponent.data.options?.showFiscalYear"
                        [hideCurrentYear]="selectedComponent.data.options?.hideCurrentYear"
                        [showPreviousYear]="
                            selectedComponent.previousYearData == null
                                ? undefined
                                : selectedComponent.data.options?.showPreviousYear
                        "
                        [pageBreak]="selectedComponent.data.options?.pageBreak"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        [isHidden]="selectedComponent.isHidden"
                        (onDeleteItem)="onDelete(componentIndex)"
                        (onAddItem)="onAdd(selectedComponent, componentIndex)"
                        (resetValuesFromMappingTriggered)="resetChildComponent(componentIndex)"
                        (onTransposeTriggered)="onTransposeButtonClick(selectedComponent, componentIndex)"
                        (onFlipSignTriggered)="onFlipSignsButtonClick(selectedComponent, componentIndex)"
                        (onTotalSignTriggered)="onTotalSignsButtonClick(selectedComponent, componentIndex)"
                        (onCompareYearsTriggered)="onCompareYearsButtonClick(selectedComponent, componentIndex)"
                        (onHideCurrentYearTriggered)="onHideCurrentYearButtonClick(selectedComponent, componentIndex)"
                        (onShowPreviousYearTriggered)="onShowPreviousYearButtonClick(selectedComponent, componentIndex)"
                        (onPageBreakTriggered)="onPageBreakButtonClick(selectedComponent, componentIndex)"
                        [settings]="selectedComponent.data.options?.settings"
                        (onToggleSettings)="onSettingsToggle(selectedComponent, componentIndex)"
                        (onToggleFootnote)="onToggleFootnote(selectedComponent, componentIndex)"
                        (onShowBalanceSheetDateTriggered)="
                            onShowBalanceSheetDateButtonClick(selectedComponent, componentIndex)
                        "
                        (onShowFiscalYearTriggered)="onShowFiscalYearButtonClick(selectedComponent, componentIndex)"
                        (onCopyItem)="onCopyComponent(selectedComponent, componentIndex)"
                        (onToggleVisibility)="onToggleVisibility(selectedComponent, componentIndex)"
                        [showCurrency]="selectedComponent.data.options?.showCurrency"
                        (onShowCurrencyTriggered)="onShowCurrencyButtonClick(selectedComponent, componentIndex, $event)"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                        [fxDisplayCurrency]="
                            fxNotesContext != null && selectedComponent.componentName === componentNames.SUPER_TABLE
                                ? fxNotesContext.displayCurrency
                                : undefined
                        "
                        [fxHideCurrentYear]="selectedComponent.data.options?.fxHideCurrentYear"
                        [fxHidePreviousYear]="selectedComponent.data.options?.fxHidePreviousYear"
                        (onFxHideCurrentYearTriggered)="onFxHideCurrentYearButtonClick(selectedComponent, componentIndex)"
                        (onFxHidePreviousYearTriggered)="onFxHidePreviousYearButtonClick(selectedComponent, componentIndex)"
                    >
                        <!-- FX (REV-21512): 3-state currency chip on FLI components — projected as
                             the first entry of the actions palette (top right), cycles
                             functional → both → display for editor, preview and print alike -->
                        <span
                            *ngIf="
                                fxNotesContext != null &&
                                selectedComponent.componentName === componentNames.FINANCIAL_LINE_ITEM
                            "
                            class="fx-currency-chip"
                            [hamTooltip]="'aumico_notes_fli_currency_chip_tooltip' | i18next"
                            tooltipPosition="top"
                            (click)="cycleFliCurrencyDisplay(selectedComponent, componentIndex)"
                        >
                            {{ fliCurrencyChipLabel(selectedComponent) }}
                        </span>
                    </notes-actions-palette>
                </div>

                <div class="component">
                    <aumico-notes-rich-text
                        #dynamicComponent
                        *ngSwitchCase="componentNames.RICH_TEXT"
                        class="selected-components__item__rich-text"
                        [delegate]="this"
                        [language]="reportLocale"
                        [translatableTexts]="selectedComponent.data"
                        [disableRichText]="false"
                        [viewMode]="viewModeEnum.EDIT"
                        [componentIndex]="componentIndex"
                    >
                    </aumico-notes-rich-text>

                    <aumico-notes-equity
                        #dynamicComponent
                        *ngSwitchCase="componentNames.EQUITY"
                        [editable]="true"
                        [delegate]="this"
                        [componentIndex]="componentIndex"
                        [language]="reportLocale"
                        [equityData]="selectedComponent.data"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        [viewMode]="viewModeEnum.EDIT"
                        [highlightTodos]="highlightTodos"
                        [addNumbering]="dataToBeSaved[componentIndex]?.addNumbering"
                        [addReferencing]="
                            selectedComponent.data?.referenceFlis != null &&
                            selectedComponent.data?.referenceFlis.length > 0
                        "
                        [referenceFlis]="selectedComponent.data?.referenceFlis"
                        [tableNumber]="notesNumberedTitles[componentIndex]?.tableNumbers[0]"
                        (onOpenTableReferenceDialog)="onOpenTableReferenceDialog(selectedComponent, componentIndex)"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                    >
                    </aumico-notes-equity>

                    <aumico-notes-fli
                        #dynamicComponent
                        *ngSwitchCase="componentNames.FINANCIAL_LINE_ITEM"
                        [flis]="flisWithAccounts"
                        [delegate]="this"
                        [componentOptions]="selectedComponent.data.options"
                        [fliData]="selectedComponent.data"
                        [state]="selectedComponent.state"
                        [language]="reportLocale"
                        [editable]="true"
                        [viewMode]="viewModeEnum.EDIT"
                        [printIndex]="accordionIndex + 1"
                        [componentIndex]="componentIndex"
                        [resetValuesFromMappingTriggered]="resetState[componentIndex]"
                        [highlightTodos]="highlightTodos"
                        [tableNumbers]="notesNumberedTitles[componentIndex]?.tableNumbers"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        (onDropFli)="onDropFli($event.previousIndex, $event.currentIndex, componentIndex)"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                        [fxNotesContext]="fxNotesContext"
                        [fliFxStamps]="fliFxStamps"
                    >
                    </aumico-notes-fli>

                    <aumico-notes-free-table-with-amounts2
                        #dynamicComponent
                        *ngSwitchCase="componentNames.FREE_TABLE_WITH_AMOUNTS"
                        [editable]="true"
                        [componentOptions]="selectedComponent.data?.options"
                        [freeTableData]="selectedComponent.data"
                        [delegate]="this"
                        [language]="reportLocale"
                        [viewMode]="viewModeEnum.EDIT"
                        [componentIndex]="componentIndex"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        [savedFootnote]="selectedComponent.data?.footnotes?.[0]"
                        (onOpenTableReferenceDialog)="onOpenTableReferenceDialog(selectedComponent, componentIndex)"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                        [addNumbering]="dataToBeSaved[componentIndex]?.addNumbering"
                        [tableNumber]="notesNumberedTitles[componentIndex]?.tableNumbers[0]"
                        [addReferencing]="
                            selectedComponent.data?.referenceFlis != null &&
                            selectedComponent.data?.referenceFlis.length > 0
                        "
                        [referenceFlis]="selectedComponent.data?.referenceFlis"
                        [highlightTodos]="highlightTodos"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                    >
                    </aumico-notes-free-table-with-amounts2>

                    <aumico-notes-select
                        #dynamicComponent
                        class="selected-components__item__select"
                        *ngSwitchCase="componentNames.SELECT"
                        [language]="reportLocale"
                        [componentIndex]="componentIndex"
                        [supportedLocales]="languages"
                        [componentOptions]="selectedComponent.data?.options"
                        [componentData]="selectedComponent.data"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        [delegate]="this"
                        [viewMode]="viewModeEnum.EDIT"
                        [addNumbering]="dataToBeSaved[componentIndex]?.addNumbering"
                        [tableNumber]="notesNumberedTitles[componentIndex]?.tableNumbers[0]"
                        [addReferencing]="
                            dataToBeSaved[componentIndex]?.referenceFlis != null &&
                            dataToBeSaved[componentIndex]?.referenceFlis.length > 0
                        "
                        [referenceFlis]="dataToBeSaved[componentIndex]?.referenceFlis"
                        (onStatusChange)="onFormStatusChange($event, componentIndex)"
                        (onSettingsStatusChange)="onSettingsClose($event, componentIndex)"
                        (onOpenTableReferenceDialog)="onOpenTableReferenceDialog(selectedComponent, componentIndex)"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                        [highlightTodos]="highlightTodos"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                    >
                    </aumico-notes-select>

                    <aumico-notes-input
                        #dynamicComponent
                        *ngSwitchCase="componentNames.INPUT"
                        [language]="reportLocale"
                        [languages]="languages"
                        [componentOptions]="selectedComponent.data?.options"
                        [componentData]="selectedComponent.data"
                        [delegate]="this"
                        [previewMode]="false"
                        [viewMode]="viewModeEnum.EDIT"
                        [componentIndex]="componentIndex"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                        [addNumbering]="selectedComponent.addNumbering"
                        (onStatusChange)="onFormStatusChange($event, componentIndex)"
                        (onOpenReferenceDialog)="onOpenTableReferenceDialog(selectedComponent, componentIndex)"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                        [highlightTodos]="highlightTodos"
                    >
                    </aumico-notes-input>

                    <aumico-notes-movements-schedule
                        #dynamicComponent
                        *ngSwitchCase="componentNames.MOVEMENT_SCHEDULE"
                        [data]="selectedComponent.data"
                        [flis]="movementScheduleFlis"
                        [reportLocale]="reportLocale"
                        [componentIndex]="componentIndex"
                        [delegate]="this"
                        [viewMode]="viewModeEnum.EDIT"
                        [resetValuesFromMappingTriggered]="resetState[componentIndex]"
                        [highlightTodos]="highlightTodos"
                        [tableNumbers]="notesNumberedTitles[componentIndex]?.tableNumbers"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                    ></aumico-notes-movements-schedule>

                    <aumico-notes-super-table
                        #dynamicComponent
                        *ngSwitchCase="componentNames.SUPER_TABLE"
                        [language]="reportLocale"
                        [componentOptions]="selectedComponent.data?.options"
                        [componentData]="selectedComponent.data"
                        [hasFootnotes]="selectedComponent.hasFootnotes"
                        [previousYearComponentData]="selectedComponent.previousYearData"
                        [delegate]="this"
                        [viewMode]="viewModeEnum.EDIT"
                        [componentIndex]="componentIndex"
                        [annualReportDefaultSettings]="annualReportDefaultSettings"
                        [fxNotesContext]="fxNotesContext"
                        [balanceMappingItemsSelectionTree]="balanceMappingItemsSelectionTree"
                        [incomeMappingItemsSelectionTree]="incomeMappingItemsSelectionTree"
                        [resetValuesFromMappingTriggered]="resetState[componentIndex]"
                        [addNumbering]="dataToBeSaved[componentIndex]?.addNumbering"
                        [tableNumber]="notesNumberedTitles[componentIndex]?.tableNumbers[0]"
                        [addReferencing]="
                            dataToBeSaved[componentIndex]?.referenceFlis != null &&
                            dataToBeSaved[componentIndex]?.referenceFlis.length > 0
                        "
                        [referenceFlis]="dataToBeSaved[componentIndex]?.data?.referenceFlis"
                        [highlightTodos]="highlightTodos"
                        [autofillMode]="autofillMode"
                        (onOpenTableReferenceDialog)="onOpenTableReferenceDialog(selectedComponent, componentIndex)"
                        (onAddNumberToggleEmit)="onAddTableNumberToggleEmit($event, selectedComponent, componentIndex)"
                    >
                    </aumico-notes-super-table>
                </div>
            </div>
            <div class="add-component-section">
                <div class="line"></div>
                <ham-button
                    icon="assets/hamIcons/circle-plus.svg"
                    type="submit"
                    variant="white-round"
                    (click)="toggleFlyoutAddMenu($event, accordionIndex, componentIndex)"
                >
                    {{ 'aumico_notes_add_component' | i18next }}
                </ham-button>
                <div
                    class="menu-flyout"
                    hamFlyout
                    #menuFlyout
                    *ngIf="isMenuOpenIndex === accordionIndex"
                    [ngStyle]="{ top: menuPosition.top + 'px', right: menuPosition.right + 'px' }"
                    [position]="menuPosition"
                    (closeFlyout)="closeFlyoutAddMenu()"
                >
                    <add-notes-component
                        [supportOperation]="supportOperation"
                        (componentAdded)="addNewComponent($event)"
                        (pasteComponent)="onPasteComponent($event)"
                    ></add-notes-component>
                </div>
                <div class="line"></div>
            </div>
        </div>
        <div *ngIf="componentData.length === 0" class="add-component-section">
            <div class="line"></div>
            <ham-button
                icon="assets/hamIcons/circle-plus.svg"
                type="submit"
                variant="white-round"
                (click)="toggleFlyoutAddMenu($event, accordionIndex, -1)"
            >
                {{ 'aumico_notes_add_component' | i18next }}
            </ham-button>
            <div
                class="menu-flyout"
                hamFlyout
                #menuFlyout
                *ngIf="isMenuOpenIndex === accordionIndex"
                [ngStyle]="{ top: menuPosition.top + 'px', right: menuPosition.right + 'px' }"
                [position]="menuPosition"
                (closeFlyout)="closeFlyoutAddMenu()"
            >
                <add-notes-component
                    [supportOperation]="supportOperation"
                    (componentAdded)="addNewComponent($event)"
                    (pasteComponent)="onPasteComponent($event)"
                ></add-notes-component>
            </div>
            <div class="line"></div>
        </div>
    </div>
</div>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showComponentDeletionModal"
    (cancel)="OnCancelDeleteComponent()"
    (action)="OnDeleteComponent()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_confirmation_modal_notes_component_deletion' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    *ngIf="showCurrentYearDeletionDialog"
    (cancel)="onCancelDeleteCurrentYear()"
    (action)="onDeleteCurrentYearColumn()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_notes_super_table_current_year_column_removal_confirmation' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
<ham-confirm-decline-modal
    *ngIf="showCompareYearsDeletionDialog"
    (cancel)="onCancelDeleteCompareYears()"
    (action)="onDeleteCompareYearsColumn()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_notes_super_table_previous_column_removal_confirmation' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
